import styles from './index.module.scss';

export const ameyoNonConnectedOptionStyles = (interactionLevel: number | undefined) => {
  if (interactionLevel === 1) {
    return styles.red;
  }
  if (interactionLevel === 2) {
    return styles.orange;
  }
  if (interactionLevel === 3) {
    return styles.green;
  }
  return styles.blue;
};
